import { render } from "./BulletText.vue?vue&type=template&id=1ac81910"
import script from "./BulletText.vue?vue&type=script&lang=js"
export * from "./BulletText.vue?vue&type=script&lang=js"

import "./BulletText.vue?vue&type=style&index=0&id=1ac81910&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__